import React from 'react';
import './Locations.css';
import MillicentImg from '../assets/images1/19.png';
import AllendaleImg from '../assets/images1/17.png';
import WulandaImg from '../assets/images1/18.png';

const Locations = () => {
  return (
    <section id="locations" className="locations-section">
      <h2>Our Locations</h2>
      <div className="locations">
        <div className="location-item">
          <div className="location-info">
            <h3 className="location-heading">Millicent</h3>
            <p>No.4 Sixth Street, Millicent, SA 5280</p>
            <p>Classes: Mon, Wed, Fri </p>
          </div>
          <img src={MillicentImg} alt="Millicent Location" className="location-image" />
        </div>

        <div className="location-item">
          <div className="location-info">
            <h3 className="location-heading">Allendale East</h3>
            <p>Allendale East Public Hall SA 5291</p>
            <p>Classes: Tuesday</p>
          </div>
          <img src={AllendaleImg} alt="Allendale East Location" className="location-image" />
        </div>

        <div className="location-item">
          <div className="location-info">
            <h3 className="location-heading">Mount Gambier</h3>
            <p>Wulanda Recreation and Convention Centre, 7 Margaret Street, Mount Gambier, SA 5290</p>
            <p>Classes: Monday</p>
          </div>
          <img src={WulandaImg} alt="Mount Gambier Location" className="location-image" />
        </div>
      </div>
    </section>
  );
};

export default Locations;
